import type { Result } from "@nabla/contract";
import type { Cursor } from "./cursor.ts";

const text = /^r(0|[1-9]\d*)\.c(0|[1-9]\d*)\.p(0|[1-9]\d*)\.a(0|[1-9]\d*)$/;

export function formatCursor(cursor: Cursor): string {
  return `r${cursor.r}.c${cursor.c}.p${cursor.p}.a${cursor.a}`;
}

export function parseCursor(written: string): Result<Cursor> {
  const sequences = text.exec(written)?.slice(1).map(Number) ?? [];
  const [r, c, p, a] = sequences;
  if (r === undefined || c === undefined || p === undefined || a === undefined || !sequences.every(Number.isSafeInteger)) {
    return { ok: false, reason: `"${written}" is not a cursor; it looks like r12.c40.p3.a77` };
  }
  return { ok: true, value: { r, c, p, a } };
}
